import React, {useEffect, useState} from "react";
import {Box, Fade, IconButton, InputBase, Modal, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Cancel01Icon} from "@hugeicons/core-free-icons";
import {controlSx, FieldHelper, FieldLabel, modalCancelSx, ModalButton, modalPaperSx, modalSaveSx} from "../../../components/modals/formFieldShared";

const EMPTY_LANGUAGE = {language: "", code: "", lang: ""};

export const LanguageDialog = ({open, handleClose, selectedLanguage, onSubmit}) => {
  const [language, setLanguage] = useState(EMPTY_LANGUAGE);
  const [loading, setLoading] = useState(false);

  const isEdit = Boolean(selectedLanguage?.id);

  useEffect(() => {
    setLanguage(selectedLanguage
      ? {language: selectedLanguage.language || "", code: selectedLanguage.code || "", lang: selectedLanguage.lang || ""}
      : EMPTY_LANGUAGE);
  }, [selectedLanguage, open]);

  const onChange = (e) => {
    const {name, value} = e.target;
    setLanguage(prev => ({...prev, [name]: value}));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!language.language.trim() || !language.code.trim()) return;
    setLoading(true);
    const success = await onSubmit({
      language: language.language.trim(),
      code: language.code.trim(),
      lang: language.lang.trim(),
    });
    setLoading(false);
    if (success) handleClose();
  };

  return (
    <Modal open={open} onClose={loading ? undefined : handleClose}>
      <Fade in={open}>
        <Box component={"form"} onSubmit={handleSubmit} sx={{...modalPaperSx(420), p: {xs: 2.5, md: 3}}}>
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} sx={{mb: 3}}>
            <Typography sx={{fontSize: 18, fontWeight: 700, color: "#23264D", letterSpacing: "-0.01em"}}>
              {isEdit ? "Edit" : "Add"} Language
            </Typography>
            <IconButton size={"small"} onClick={loading ? undefined : handleClose} sx={{color: "#8A8AA0"}}>
              <HugeiconsIcon icon={Cancel01Icon} size={18}/>
            </IconButton>
          </Stack>

          <Stack gap={2} sx={{mb: 3}}>
            <Box>
              <FieldLabel required>Language</FieldLabel>
              <Box sx={controlSx}>
                <InputBase
                  name={"language"} autoFocus placeholder={"e.g. Macedonian"} value={language.language}
                  onChange={onChange} inputProps={{"aria-label": "Language"}} sx={{flex: 1, fontSize: 13, color: "#23264D"}}
                />
              </Box>
            </Box>
            <Box>
              <FieldLabel required>Code</FieldLabel>
              <Box sx={controlSx}>
                <InputBase
                  name={"code"} placeholder={"e.g. mk"} value={language.code}
                  onChange={onChange} inputProps={{"aria-label": "Code"}} sx={{flex: 1, fontSize: 13, color: "#23264D"}}
                />
              </Box>
            </Box>
            <Box>
              <FieldLabel>Lang</FieldLabel>
              <Box sx={controlSx}>
                <InputBase
                  name={"lang"} value={language.lang}
                  onChange={onChange} inputProps={{"aria-label": "Lang"}} sx={{flex: 1, fontSize: 13, color: "#23264D"}}
                />
              </Box>
              <FieldHelper>Language identifier copied into project settings</FieldHelper>
            </Box>
          </Stack>

          <Stack direction={"row"} gap={1.5} justifyContent={"flex-end"}>
            <ModalButton onClick={loading ? undefined : handleClose} sx={modalCancelSx}>Cancel</ModalButton>
            <ModalButton type={"submit"} disabled={loading} sx={modalSaveSx}>
              {isEdit ? "Update" : "Add Language"}
            </ModalButton>
          </Stack>
        </Box>
      </Fade>
    </Modal>
  );
};
